function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgCondominioFechado = function SvgCondominioFechado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.643 22.306v5.29H20.5v-5.29h-1.857zm-1 0v-2.435c0-1.056-.85-1.92-1.881-1.92-1.032 0-1.881.864-1.881 1.92V30.5h3.762v-8.193zm1-1H20.5v-1.435c0-1.605 1.293-2.92 2.881-2.92 1.587 0 2.88 1.315 2.88 2.92v1.435h1.858v-1.435c0-1.605 1.294-2.92 2.881-2.92v1c-1.032 0-1.881.864-1.881 1.92V30.5H31v1h-2.381a.5.5 0 01-.5-.5v-2.403h-1.857V31a.5.5 0 01-.5.5H21a.5.5 0 01-.5-.5v-2.403h-1.857V31a.5.5 0 01-.5.5H13.38a.5.5 0 01-.5-.5V19.871c0-1.605 1.293-2.92 2.88-2.92 1.588 0 2.882 1.315 2.882 2.92v1.435zm2.857 7.29V30.5h3.762V19.871c0-1.056-.85-1.92-1.881-1.92-1.032 0-1.881.864-1.881 1.92v8.725zm4.762-6.29v5.29h1.857v-5.29h-1.857zM10.548 9.546l1.975-1.505.606.796-2.581 1.967v14.873a.5.5 0 01-.5.5H.5v-1h9.048V5.823h1v3.724zM10.048.5c2.74 0 4.99 2.126 5.239 4.839 2.372 0 4.308 1.968 4.308 4.37 0 2.404-1.936 4.372-4.31 4.372H11.93v-1h3.357c1.817 0 3.31-1.517 3.31-3.371 0-1.855-1.493-3.371-3.31-3.371h-.476a.5.5 0 01-.5-.5c0-2.398-1.91-4.339-4.262-4.339-2.352 0-4.262 1.94-4.262 4.339a.5.5 0 01-.5.5H4.81c-1.818 0-3.31 1.516-3.31 3.37 0 1.855 1.492 3.372 3.31 3.372h3.357v1H4.81C2.436 14.08.5 12.113.5 9.71c0-2.403 1.936-4.37 4.308-4.371C5.057 2.626 7.306.5 10.048.5z"
  }));
};
SvgCondominioFechado.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgCondominioFechado.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgCondominioFechado;